import {
  APP_PLAYBOOK_MESSAGING_EMAIL,
  APP_PLAYBOOK_MESSAGING_LINKEDIN,
  APP_PLAYBOOK_MESSAGING_PITCH,
  APP_PLAYBOOK_MESSAGING_QQ,
  APP_PLAYBOOK_MESSAGING_SNIPPET,
} from '../app/_constants/routes';
import { TYPES } from '../constants/templates';

export const TEMPLATE_TYPES = Object.freeze({
  SNIPPET: 'SNIPPET',
  PITCH: 'PITCH',
  EMAIL: 'EMAIL',
  LINKEDIN_MESSAGE: 'LINKEDIN_MESSAGE',
  LINKEDIN: 'LINKEDIN_MESSAGE',
  QUALIFYING_QUESTION: 'QUALIFYING_QUESTION',
});

export const QQ_TYPES = Object.freeze({
  GLOBAL_PICKLIST: 'GLOBAL_PICKLIST',
  MULTI_GLOBAL_PICKLIST: 'MULTI_GLOBAL_PICKLIST',
  TEXT: 'TEXT',
});

export const QQ_TYPES_COPIES = Object.freeze({
  GLOBAL_PICKLIST: 'Picklist',
  MULTI_GLOBAL_PICKLIST: 'Multi Picklist',
  TEXT: 'Text',
});

export const TEMPLATE_TYPES_COPIES = Object.freeze({
  SNIPPET: 'Snippet',
  PITCH: 'Pitch',
  EMAIL: 'Email',
  LINKEDIN_MESSAGE: 'Linkedin',
  LINKEDIN: 'Linkedin',
  QUALIFYING_QUESTION: 'qualifying question',
});

export const TEMPLATE_TYPES_ICONS = Object.freeze({
  SNIPPET: 'snippet',
  PITCH: 'alignLeft',
  EMAIL: 'mail',
  LINKEDIN_MESSAGE: 'linkedin',
  LINKEDIN: 'linkedin',
  QUALIFYING_QUESTION: 'chat',
});

export const FORM_MODES = Object.freeze({
  EDITION: 'EDITION',
  CREATION: 'CREATION',
  CLONE: 'CLONE',
});

export const typeToUrl = type => {
  if (type === TYPES.EMAIL) {
    return APP_PLAYBOOK_MESSAGING_EMAIL;
  }
  if (type === TYPES.LINKEDIN) {
    return APP_PLAYBOOK_MESSAGING_LINKEDIN;
  }
  if (type === TYPES.PITCH) {
    return APP_PLAYBOOK_MESSAGING_PITCH;
  }
  if (type === TYPES.SNIPPET) {
    return APP_PLAYBOOK_MESSAGING_SNIPPET;
  }
  if (type === TYPES.QUALIFYING_QUESTION) {
    return APP_PLAYBOOK_MESSAGING_QQ;
  }
  return '';
};
